export default __webpack_public_path__ + "static/media/logo-web.b39fc2a7.png";